<template>
  <div v-if="aGuide.user" class="single-team">
    <div
      class="video"
      v-if="aGuide.profile.videoURL"
      @click="$bvModal.show('video-modal')"
    >
      <span class="ico">
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.99999 2.00002C4.68628 2.00002 1.99999 4.68631 1.99999 8.00002C1.99999 11.3137 4.68628 14 7.99999 14C11.3137 14 14 11.3137 14 8.00002C14 4.68631 11.3137 2.00002 7.99999 2.00002ZM0.666656 8.00002C0.666656 3.94993 3.9499 0.666687 7.99999 0.666687C12.0501 0.666687 15.3333 3.94993 15.3333 8.00002C15.3333 12.0501 12.0501 15.3334 7.99999 15.3334C3.9499 15.3334 0.666656 12.0501 0.666656 8.00002Z"
            fill="#557EFB"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.35209 4.74557C6.56887 4.62956 6.8319 4.64227 7.03647 4.77865L11.0365 7.44532C11.2219 7.56897 11.3333 7.77712 11.3333 8.00002C11.3333 8.22292 11.2219 8.43108 11.0365 8.55472L7.03647 11.2214C6.8319 11.3578 6.56887 11.3705 6.35209 11.2545C6.13532 11.1385 6 10.9126 6 10.6667V5.33335C6 5.08749 6.13532 4.86158 6.35209 4.74557ZM7.33333 6.57903V9.42101L9.46482 8.00002L7.33333 6.57903Z"
            fill="#557EFB"
          />
        </svg>
      </span>
      Play
    </div>

    <div @click="handleGuideClick(aGuide)">
      <div class="team-image">
        <img :src="aGuide.user.imgURL" :alt="aGuide.user.firstname" />
      </div>

      <div class="team-content" key="member.firstName">
        <div class="team-info">
          <h3>{{ aGuide.user.firstname }} {{ aGuide.user.lastname }}</h3>
          <!-- <span class="ico">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="8" cy="8" r="8" fill="#557EFB" />
              <path
                d="M4.96463 4.5588C4.96463 5.98468 6.87138 7.74012 7.99652 8.45579C9.20629 7.67641 11.0135 6.3382 11.0135 4.72058C11.0135 3.95236 10.5654 3 9.63941 3C8.89862 3 8.31016 3.32355 7.99652 3.91175C7.66794 3.30884 6.80168 3 6.38349 3C5.9653 3 4.96463 3 4.96463 4.5588Z"
                stroke="white"
                stroke-width="0.6"
              />
              <path
                d="M5.86077 10.9116C5.83588 10.7793 5.57701 10.3381 5.57701 10.3381L4.72568 9.52932C4.72568 9.52932 4.27763 9.05874 4.00879 8.74992C3.73995 8.4411 3.71508 8.16169 3.78478 7.98522C3.82712 7.87801 3.97894 7.79405 4.03868 7.79405M4.03868 7.79405C4.11336 7.77934 4.30752 7.8088 4.42698 7.9264C4.56142 8.05875 5.20362 8.6911 5.57701 9.05874C5.95039 9.42638 7.14525 9.91166 7.35434 10.4264C7.56344 10.9411 7.41408 12.191 7.41408 13.044L5.33804 13.0587C5.40276 12.8234 5.33804 12.3381 5.33804 11.9116C5.33804 11.251 4.57635 10.6911 4.33739 10.5146C4.09843 10.3381 3.08279 9.52932 3.08279 9.05874C3.08278 8.14509 2.94721 6.38077 3.02306 5.76467C3.08281 5.27939 3.14253 5.01468 3.41137 5.11762C3.68021 5.22056 3.79969 5.43527 3.79969 5.8235C3.79969 6.21173 3.96898 7.29997 4.03868 7.79405Z"
                stroke="white"
                stroke-width="0.6"
              />
              <path
                d="M10.1392 10.9116C10.1641 10.7793 10.423 10.3381 10.423 10.3381L11.2743 9.52932C11.2743 9.52932 11.7224 9.05874 11.9912 8.74992C12.26 8.4411 12.2849 8.16169 12.2152 7.98522C12.1729 7.87801 12.0211 7.79405 11.9613 7.79405M11.9613 7.79405C11.8866 7.77934 11.6925 7.8088 11.573 7.9264C11.4386 8.05875 10.7964 8.6911 10.423 9.05874C10.0496 9.42638 8.85475 9.91166 8.64566 10.4264C8.43656 10.9411 8.58592 12.191 8.58592 13.044L10.662 13.0587C10.5972 12.8234 10.662 12.3381 10.662 11.9116C10.662 11.251 11.4236 10.6911 11.6626 10.5146C11.9016 10.3381 12.9172 9.52932 12.9172 9.05874C12.9172 8.14509 13.0528 6.38077 12.9769 5.76467C12.9172 5.27939 12.8575 5.01468 12.5886 5.11762C12.3198 5.22056 12.2003 5.43527 12.2003 5.8235C12.2003 6.21173 12.031 7.29997 11.9613 7.79405Z"
                stroke="white"
                stroke-width="0.6"
              />
            </svg>
          </span> -->
        </div>
        <p v-if="aGuide.profile && aGuide.profile.tags" class="main-line">
          <template v-for="(tag, n) in aGuide.profile.tags">
            {{ (n &lt; 2) ? tag.text : '' }} <br :key="n" v-if="n == 0" />
          </template>
          <span
            >{{aGuide.profile.tags.length &gt; 2 ? aGuide.profile.tags.length+ '+ more' :''}}</span
          >
        </p>
        <div class="rating" v-if="aGuide.profile && aGuide.profile.rating">
          <span
            class="ico filled"
            v-for="star in aGuide.profile.rating"
            :key="star + 10"
          >
            <svg
              width="17"
              height="16"
              viewBox="0 0 17 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.4505 5.63406L11.3543 4.90408L9.07611 0.352135C9.01388 0.227506 8.91152 0.126615 8.78506 0.0652895C8.46793 -0.0890138 8.08254 0.0395723 7.92397 0.352135L5.64581 4.90408L0.549539 5.63406C0.409035 5.65384 0.280575 5.71912 0.182222 5.81803C0.0633192 5.93848 -0.00220171 6.10053 5.64944e-05 6.26856C0.0023147 6.4366 0.0721672 6.59688 0.194265 6.71418L3.88148 10.2572L3.01036 15.2602C2.98993 15.3766 3.003 15.4963 3.04808 15.6057C3.09316 15.7151 3.16845 15.8099 3.26541 15.8793C3.36237 15.9488 3.47713 15.99 3.59666 15.9984C3.7162 16.0068 3.83573 15.982 3.9417 15.9269L8.50004 13.5648L13.0584 15.9269C13.1828 15.9922 13.3273 16.0139 13.4658 15.9902C13.8151 15.9308 14.0499 15.6044 13.9897 15.2602L13.1186 10.2572L16.8058 6.71418C16.9062 6.61724 16.9724 6.49064 16.9925 6.35216C17.0467 6.00597 16.8018 5.68549 16.4505 5.63406Z"
                fill="#F8D57C"
              />
            </svg>
          </span>
          <span
            class="ico empty"
            v-for="star in 5 - aGuide.profile.rating"
            :key="star"
          >
            <svg
              width="17"
              height="16"
              viewBox="0 0 17 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.4505 5.63406L11.3543 4.90408L9.07611 0.352135C9.01388 0.227506 8.91152 0.126615 8.78506 0.0652895C8.46793 -0.0890138 8.08254 0.0395723 7.92397 0.352135L5.64581 4.90408L0.549539 5.63406C0.409035 5.65384 0.280575 5.71912 0.182222 5.81803C0.0633192 5.93848 -0.00220171 6.10053 5.64944e-05 6.26856C0.0023147 6.4366 0.0721672 6.59688 0.194265 6.71418L3.88148 10.2572L3.01036 15.2602C2.98993 15.3766 3.003 15.4963 3.04808 15.6057C3.09316 15.7151 3.16845 15.8099 3.26541 15.8793C3.36237 15.9488 3.47713 15.99 3.59666 15.9984C3.7162 16.0068 3.83573 15.982 3.9417 15.9269L8.50004 13.5648L13.0584 15.9269C13.1828 15.9922 13.3273 16.0139 13.4658 15.9902C13.8151 15.9308 14.0499 15.6044 13.9897 15.2602L13.1186 10.2572L16.8058 6.71418C16.9062 6.61724 16.9724 6.49064 16.9925 6.35216C17.0467 6.00597 16.8018 5.68549 16.4505 5.63406Z"
                fill="#DDDDDD"
              />
            </svg>
          </span>
        </div>
        <ul v-if="aGuide.profile && aGuide.profile.social">
          <li v-if="aGuide.profile.social && aGuide.profile.social.facebookURL">
            <a
              :href="
                `https://facebook.com/${aGuide.profile.social.facebookURL}`
              "
              target="_blank"
            >
              <span class="">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.1173 0H0.882667C0.395333 0 0 0.395333 0 0.882667V15.1173C0 15.6053 0.395333 16 0.882667 16H8.54533V9.804H6.45933V7.39H8.54533V5.60667C8.54533 3.54067 9.808 2.41667 11.6513 2.41667C12.5347 2.41667 13.294 2.48133 13.5153 2.51067V4.67067H12.2347C11.2347 4.67067 11.04 5.15133 11.04 5.85133V7.392H13.4293L13.1193 9.812H11.04V16H15.1167C15.6053 16 16 15.6053 16 15.1173V0.882667C16 0.395333 15.6053 0 15.1173 0Z"
                    fill="#A1B1BA"
                  />
                </svg>
              </span>
            </a>
          </li>
          <li v-if="aGuide.profile.social && aGuide.profile.social.twitterURL">
            <a
              :href="`https://twitter.com/${aGuide.profile.social.twitterURL}`"
              target="_blank"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.2857 -0.020874H1.71429C0.767857 -0.020874 0 0.748983 0 1.69788V14.302C0 15.2509 0.767857 16.0208 1.71429 16.0208H14.2857C15.2321 16.0208 16 15.2509 16 14.302V1.69788C16 0.748983 15.2321 -0.020874 14.2857 -0.020874ZM12.5393 5.66532C12.5464 5.76558 12.5464 5.86943 12.5464 5.96969C12.5464 9.07418 10.1893 12.6513 5.88214 12.6513C4.55357 12.6513 3.32143 12.2646 2.28571 11.5986C2.475 11.6201 2.65714 11.6272 2.85 11.6272C3.94643 11.6272 4.95357 11.2548 5.75714 10.6246C4.72857 10.6031 3.86429 9.92639 3.56786 8.9954C3.92857 9.04911 4.25357 9.04911 4.625 8.95243C3.55357 8.73401 2.75 7.7887 2.75 6.64644V6.6178C3.06071 6.79325 3.425 6.90068 3.80714 6.915C3.48587 6.70074 3.22249 6.41007 3.04053 6.06893C2.85856 5.72779 2.76365 5.34678 2.76429 4.95992C2.76429 4.52307 2.87857 4.12203 3.08214 3.7747C4.23571 5.19983 5.96786 6.13082 7.91071 6.23108C7.57857 4.63765 8.76786 3.34501 10.1964 3.34501C10.8714 3.34501 11.4786 3.62789 11.9071 4.08622C12.4357 3.98596 12.9429 3.78902 13.3929 3.52047C13.2179 4.06474 12.85 4.52307 12.3643 4.81311C12.8357 4.76298 13.2929 4.63049 13.7143 4.44788C13.3964 4.91695 12.9964 5.33232 12.5393 5.66532Z"
                  fill="#A1B1BA"
                />
              </svg>
            </a>
          </li>
          <li v-if="aGuide.profile.social && aGuide.profile.social.linkedInURL">
            <a
              :href="
                `https://linkedIn.com/in/${aGuide.profile.social.linkedInURL}`
              "
              target="_blank"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.6313 13.6347H11.262V9.922C11.262 9.03667 11.244 7.89733 10.0273 7.89733C8.792 7.89733 8.60333 8.86067 8.60333 9.85667V13.6347H6.234V6H8.51V7.04067H8.54067C8.85867 6.44067 9.632 5.80733 10.7873 5.80733C13.188 5.80733 13.632 7.38733 13.632 9.444V13.6347H13.6313ZM3.558 4.95533C2.79533 4.95533 2.18267 4.338 2.18267 3.57867C2.18267 2.82 2.796 2.20333 3.558 2.20333C4.318 2.20333 4.934 2.82 4.934 3.57867C4.934 4.338 4.31733 4.95533 3.558 4.95533ZM4.746 13.6347H2.37V6H4.746V13.6347ZM14.8167 0H1.18067C0.528 0 0 0.516 0 1.15267V14.8473C0 15.4847 0.528 16 1.18067 16H14.8147C15.4667 16 16 15.4847 16 14.8473V1.15267C16 0.516 15.4667 0 14.8147 0H14.8167Z"
                  fill="#A1B1BA"
                />
              </svg>
            </a>
          </li>
          <li
            v-if="aGuide.profile.social && aGuide.profile.social.instagramURL"
          >
            <a
              :href="
                `https://instagram.com/${aGuide.profile.social.instagramURL}`
              "
              target="_blank"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8 5.22292C6.47083 5.22292 5.22291 6.47084 5.22291 8.00001C5.22291 9.52917 6.47083 10.7771 8 10.7771C9.52916 10.7771 10.7771 9.52917 10.7771 8.00001C10.7771 6.47084 9.52916 5.22292 8 5.22292ZM16.3292 8.00001C16.3292 6.85001 16.3396 5.71042 16.275 4.56251C16.2104 3.22917 15.9062 2.04584 14.9312 1.07084C13.9542 0.0937551 12.7729 -0.208328 11.4396 -0.272911C10.2896 -0.337495 9.15 -0.327078 8.00208 -0.327078C6.85208 -0.327078 5.7125 -0.337495 4.56458 -0.272911C3.23125 -0.208328 2.04791 0.0958385 1.07291 1.07084C0.0958305 2.04792 -0.206253 3.22917 -0.270836 4.56251C-0.33542 5.71251 -0.325003 6.85209 -0.325003 8.00001C-0.325003 9.14792 -0.33542 10.2896 -0.270836 11.4375C-0.206253 12.7708 0.0979139 13.9542 1.07291 14.9292C2.05 15.9063 3.23125 16.2083 4.56458 16.2729C5.71458 16.3375 6.85416 16.3271 8.00208 16.3271C9.15208 16.3271 10.2917 16.3375 11.4396 16.2729C12.7729 16.2083 13.9562 15.9042 14.9312 14.9292C15.9083 13.9521 16.2104 12.7708 16.275 11.4375C16.3417 10.2896 16.3292 9.15001 16.3292 8.00001ZM8 12.2729C5.63541 12.2729 3.72708 10.3646 3.72708 8.00001C3.72708 5.63542 5.63541 3.72709 8 3.72709C10.3646 3.72709 12.2729 5.63542 12.2729 8.00001C12.2729 10.3646 10.3646 12.2729 8 12.2729ZM12.4479 4.55001C11.8958 4.55001 11.45 4.10417 11.45 3.55209C11.45 3.00001 11.8958 2.55417 12.4479 2.55417C13 2.55417 13.4458 3.00001 13.4458 3.55209C13.446 3.68318 13.4203 3.81302 13.3702 3.93417C13.3201 4.05532 13.2466 4.16539 13.1539 4.25809C13.0612 4.35079 12.9511 4.42429 12.83 4.47438C12.7088 4.52447 12.579 4.55017 12.4479 4.55001Z"
                  fill="#A1B1BA"
                />
              </svg>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    aGuide: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleGuideClick(guide) {
      this.$router.push(`/crew/@${guide.profile.profileName}`);
    }
  }
};
</script>

<style lang="scss" scoped>
.rating {
  margin-top: 6px;
  margin-bottom: 20px;
  .ico {
    margin: 0 4px;
  }
}
.main-line {
  font-family: "Nunito", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  margin-top: 8px !important;
  span {
    font-family: "Nunito", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    text-transform: lowercase;
    letter-spacing: 0.05em;
    color: #557efb;
  }
}
.single-team {
  cursor: pointer;
  filter: drop-shadow(0px 12px 16px rgba(45, 38, 38, 0.04));
  border-radius: 16px;
  &:hover {
    filter: drop-shadow(0px 12px 40px rgba(45, 38, 38, 0.1));
  }
  img {
    width: 116px;
    height: 116px;
    border-radius: 50%;
    object-fit: cover;
    border: none;
  }
  .team-info {
    display: flex;
    justify-content: center;
    align-items: center;
    background: none;
    margin-bottom: 0px;
    margin-top: 22px;
    padding: 0;
    h3 {
      font-style: normal;
      font-weight: bold;
      font-size: 16px;
      line-height: 22px;
      text-transform: capitalize;
      color: #52595e;
      margin-bottom: 0;
    }
    .ico {
      margin-left: 6px;
    }
  }
  .team-image::before {
    content: none;
  }
}
.single-team {
  position: relative;
  cursor: pointer;

  .video {
    position: absolute;
    top: 16px;
    right: 16px;
    width: 67px;
    height: 24px;
    border: 1px solid #557efb;
    box-sizing: border-box;
    border-radius: 32px;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: #557efb;
    justify-content: space-evenly;
  }
  .team-image {
    padding-top: 4px;
  }
}
</style>
